import { render, staticRenderFns } from "./ficha-emergencia.vue?vue&type=template&id=452d15e6&"
import script from "./ficha-emergencia.vue?vue&type=script&lang=js&"
export * from "./ficha-emergencia.vue?vue&type=script&lang=js&"
import style0 from "./ficha-emergencia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports